var exports = {
  "i": "xaee3c4fa--f8d563--wrapper",
  "P": "xaee3c4fa--f8d563--inner-wrapper",
};

module.exports = exports;
